// extracted by mini-css-extract-plugin
export var linkText = "_ni-0";